export default __webpack_public_path__ + "static/media/watchdog-7.ed70384a.png";